import { Injectable } from '@angular/core';
import { DwUiConfigRegistryService, DwUiConfigInitDecorator, DwUiGridStyleReference,
    DwUiRegistryType, DwUiContainerStyleReference } from '@devwareapps/devware-cap';

@Injectable()
  export class AppDevwreBootstrapService {
     constructor(private uiConfigRegistyService: DwUiConfigRegistryService) {}

    @DwUiConfigInitDecorator({
        name: 'DwUiMetadataRegistrationService',
        useDI: true,
      })
      setupRegistrations() {
        this.setupContainerStyles();
        this.setupGridStyles();
      }

      private setupContainerStyles() {

        this.uiConfigRegistyService.registerItem(DwUiRegistryType.containerStyles, <DwUiContainerStyleReference>{
          keyName: 'wachter_blue',
          display: 'Wachter Blue',
          containerClass: 'dw-form-section-container2',
          containerInnerClass: 'dw-form-section-container-inner',
          containerTitleClass: 'wa-blue-title'
        });

        this.uiConfigRegistyService.registerItem(DwUiRegistryType.containerStyles, <DwUiContainerStyleReference>{
          keyName: 'read_only_wachter_blue',
          display: 'Read Only Wachter Blue',
          containerClass: 'dw-form-section-container2',
          containerInnerClass: 'read-only-wachter-blue',
          containerTitleClass: 'wa-blue-title'
        });

        this.uiConfigRegistyService.registerItem(DwUiRegistryType.containerStyles, <DwUiContainerStyleReference>{
            keyName: 'wachter_green',
            display: 'Wachter Green',
            containerClass: 'dw-form-section-container2',
            containerInnerClass: 'dw-form-section-container-inner',
            containerTitleClass: 'wa-green-title'
          });

          this.uiConfigRegistyService.registerItem(DwUiRegistryType.containerStyles, <DwUiContainerStyleReference>{
            keyName: 'wachter_yellow',
            display: 'Wachter Yellow',
            containerClass: 'dw-form-section-container2',
            containerInnerClass: 'dw-form-section-container-inner',
            containerTitleClass: 'wa-yellow-title'
          });

          this.uiConfigRegistyService.registerItem(DwUiRegistryType.containerStyles, <DwUiContainerStyleReference>{
            keyName: 'wachter_red',
            display: 'Wachter Red',
            containerClass: 'dw-form-section-container2',
            containerInnerClass: 'dw-form-section-container-inner',
            containerTitleClass: 'wa-red-title'
          });

          this.uiConfigRegistyService.registerItem(DwUiRegistryType.containerStyles, <DwUiContainerStyleReference>{
            keyName: 'wachter_red_full_width',
            display: 'Wachter Red (Full Width)',
            containerClass: 'dw-form-section-container-no-width',
            containerInnerClass: 'dw-form-section-container-inner',
            containerTitleClass: 'wa-red-title'
          });
          this.uiConfigRegistyService.registerItem(DwUiRegistryType.containerStyles, <DwUiContainerStyleReference>{
            keyName: 'wachter_orange',
            display: 'Wachter Orange',
            containerClass: 'dw-form-section-container2',
            containerInnerClass: 'dw-form-section-container-inner',
            containerTitleClass: 'wa-orange-title'
          });
      }

      private setupGridStyles() {

        // Override the devware default which now uses a larger font
        this.uiConfigRegistyService.registerItem(DwUiRegistryType.gridStyles, <DwUiGridStyleReference>{
          keyName: '',
          display: 'Default',
          containerClass: 'dw-grid-container',
          filterHeaderClass: 'dw-grid-filter-header',
          filterBodyClass: 'dw-grid-filter-body',
          actionBarClass: 'dw-grid-action-bar',
          rowHeight: 25,
        });

        /* Based on Default */
        this.uiConfigRegistyService.registerItem(DwUiRegistryType.gridStyles, <DwUiGridStyleReference>{
          keyName: 'Default-Large-Font',
          display: 'Default - Large Font',
          containerClass: 'dw-grid-container wachter-large-font-grid',
          filterHeaderClass: 'dw-grid-filter-header',
          filterBodyClass: 'dw-grid-filter-body',
          actionBarClass: 'dw-grid-action-bar',
        });
        this.uiConfigRegistyService.registerItem(DwUiRegistryType.gridStyles, <DwUiGridStyleReference>{
          keyName: 'Simple-Large-Font',
          display: 'Simple - Large Font',
          containerClass: 'dw-grid-container-simple  wachter-large-font-grid',
          filterHeaderClass: 'dw-grid-filter-header',
          filterBodyClass: 'dw-grid-filter-body',
          actionBarClass: 'dw-grid-action-bar',
        });
          // Use this section to create custom grid styles
       /*  this.uiConfigRegistyService.registerItem(DwUiRegistryType.gridStyles, <DwUiGridStyleReference>{
            keyName: '',
            display: 'Default',
            containerClass: 'dw-grid-container',
            filterHeaderClass: 'dw-grid-filter-header',
            filterBodyClass: 'dw-grid-filter-body',
            actionBarClass: 'dw-grid-action-bar',
          });

          this.uiConfigRegistyService.registerItem(DwUiRegistryType.gridStyles, <DwUiGridStyleReference>{
            keyName: 'Simple',
            display: 'Simple',
            containerClass: 'dw-grid-container-simple',
            filterHeaderClass: 'dw-grid-filter-header',
            filterBodyClass: 'dw-grid-filter-body',
            actionBarClass: 'dw-grid-action-bar',
          }); */
      }
  }
